import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface BossIntroProps {
  wordCount: number;
  onStart: () => void;
  /** Десктоп подписывает Enter и слушает его; на мобиле только кнопка. */
  withKeyboard: boolean;
}

/** Заставка финального раунда. Правила — тремя короткими шагами, дальше сразу
 *  матч. Выход и «завершить» живут в шапке сцены, здесь только старт. */
export function BossIntro({ wordCount, onStart, withKeyboard }: BossIntroProps) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!withKeyboard) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key !== 'Enter') return;
      e.preventDefault();
      onStart();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onStart, withKeyboard]);

  return (
    <main className="st-body st-intro">
      <div className="st-eyebrow">{t('session.boss.eyebrow', 'финальный раунд')}</div>
      <h1 className="st-intro-title">{t('session.boss.title', 'Соедини пары')}</h1>
      <p className="st-intro-sub">{t('session.boss.intro', { count: wordCount })}</p>
      <div className="st-intro-steps">
        <span>
          <b>1</b> {t('session.boss.step1', 'слово слева')}
        </span>
        <i aria-hidden>→</i>
        <span>
          <b>2</b> {t('session.boss.step2', 'перевод справа')}
        </span>
        <i aria-hidden>→</i>
        <span>{t('session.boss.step3', 'пара исчезает')}</span>
      </div>
      <button type="button" className="st-cta" onClick={onStart}>
        {t('session.boss.start', 'Начать')}
        {withKeyboard && <kbd>Enter</kbd>}
      </button>
    </main>
  );
}
